// users.js (Vuex-Modul)

import axios from '@/api/client';

let initializeAuthPromise = null;

const state = {
  user: null,
  authInitialized: false,
  authLoading: false,
};

const getters = {
  isAuthenticated: (state) => !!state.user,
  isAuthInitialized: (state) => state.authInitialized,
  isAuthLoading: (state) => state.authLoading,
  stateUser: (state) => state.user || {},
};

const actions = {
  async changeUserPassword(_, { oldPassword, newPassword }) {
    const { data } = await axios.post('changepassword', {
      password: oldPassword,
      newPassword,
    }, { skipAuthRedirect: true });
    return data;
  },
  async logIn({ commit, dispatch }, user) {
  console.log('Login klassisch (Store):', user);
  commit('logout');
  commit('setAuthInitialized', true);

  // Wir umgehen hier alle globalen validateStatus/Interceptor-Tricks
  const response = await axios.post('login', user, {
    // egal welcher Status zurückkommt: Axios soll NICHT throwen,
    // sondern wir entscheiden danach selbst:
    validateStatus: () => true,
  });

  console.log('Login response status:', response.status, response.data);

  // 🔴 Wenn kein 2xx, Login als FEHLER behandeln:
  if (response.status < 200 || response.status >= 300) {
    // künstlichen Error basteln, wie Axios ihn normalerweise liefern würde
    const error = new Error('Login fehlgeschlagen');
    error.response = response;
    console.error('Login error in Store (manuell):', error);
    throw error; // ⬅️ geht in dein submit()-catch
  }

  // ✅ Nur bei Erfolg 2xx:
  const loggedInUser = await dispatch('viewMe');
  const requestedUsername = String(user?.get?.('username') || '').trim();
  const authenticatedUsername = String(loggedInUser?.user_username || loggedInUser?.username || '').trim();
  if (requestedUsername && authenticatedUsername && requestedUsername !== authenticatedUsername) {
    commit('logout');
    const error = new Error('Login-Benutzer passt nicht zur aktiven Session');
    error.response = {
      status: 401,
      data: { detail: 'Aktive Session gehoert zu einem anderen User.' },
    };
    throw error;
  }
  return loggedInUser;
  },

  async viewMe({ commit }) {
    const { data } = await axios.get('users/whoami', { skipAuthRedirect: true });
    commit('setUser', data);
    commit('setAuthInitialized', true);
    return data;
  },

  async initializeAuth({ commit, dispatch, state }) {
    if (state.authInitialized) {
      return state.user;
    }

    if (initializeAuthPromise) {
      return initializeAuthPromise;
    }

    commit('setAuthLoading', true);

    initializeAuthPromise = dispatch('viewMe')
      .catch(() => {
        commit('logout');
        return null;
      })
      .finally(() => {
        commit('setAuthInitialized', true);
        commit('setAuthLoading', false);
        initializeAuthPromise = null;
      });

    return initializeAuthPromise;
  },

  async logOut({ commit }) {
    commit('logout');
    commit('setAuthInitialized', true);
  },
};

const mutations = {
  setUser(state, user) {
    state.user = user;
  },
  setAuthInitialized(state, initialized) {
    state.authInitialized = !!initialized;
  },
  setAuthLoading(state, loading) {
    state.authLoading = !!loading;
  },
  logout(state) {
    state.user = null;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
